<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/baixaRequisicao', query: $route.query }">
        Almoxarifado/Baixar Requisição
      </router-link>
      <label class="labelBar"> / </label>
      <label> Baixar </label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="6" sm="2">
            <v-text-field
              label="Unidade Administrativa"
              v-model="unidadeAdm"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="2">
            <v-text-field
              label="Local de Entrega"
              v-model="local"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4">
            <v-text-field
              label="Requisitante"
              v-model="requisitante"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="2">
            <v-text-field
              label="Prioridade"
              v-model="prioridade"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="2">
            <v-text-field
              label="N° Requisição"
              v-model="nome"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              label="Observações"
              v-model="observacao"
              prepend-icon="mdi-comment"
              clear-icon="mdi-close-circle"
              readonly
            ></v-textarea>
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="3000"
          >A quantidade deve ser entre 0 até a mesma quantidade requisitada!
        </v-snackbar>
      </v-form>

      <v-card>
        <v-data-table
          :headers="headers"
          :items-per-page="-1"
          hide-default-footer
          :items="produtosL"
        >
          <template v-slot:item.quantidadeAtendida="{ item }">
            <v-text-field
              v-model="item.quantidadeAtendida"
              single-line
              type="number"
              v-mask="['#####']"
              :rules="[
                (v) =>
                  (!!v && v >= 0 && v <= item.quantidadeAprovada) ||
                  'A quantidade deve ser 0 até a quantidade requisitada!',
              ]"
              @input="updateItem(item)"
              required
              :disabled="!item.quantidadeAprovada > 0"
            >
            </v-text-field>
          </template>
          <template v-slot:item.autorizado="{ item }">
            {{ item.autorizado ? "Sim" : "Não" }}
          </template>
        </v-data-table>
      </v-card>

      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn
            @click="gerar"
            color="primary"
            class="mr-4"
            :disabled="isGreaterThanZero()"
          >
            Gerar Solicitação
          </v-btn>
          <v-btn
            :to="{ path: '/baixaRequisicao', query: $route.query }"
            color="error"
            class="mr-4"
          >
            Voltar
          </v-btn>
          <v-btn
            @click="baixar"
            color="success"
            class="mr-4"
            :disabled="!isWriteOff(idModulo) || isEqualToZero()"
          >
            Baixar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>

    <v-dialog
      style="z-index: 19999"
      v-model="showModal"
      persistent
      max-width="1550px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ this.labelModal }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="12" sm="2">
                <v-text-field
                  label="Data Hora"
                  v-model="data"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  label="Unidade Administrativa"
                  v-model="unidadeAdm"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  label="Local de Entrega"
                  v-model="local"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Solicitante"
                  v-model="requisitante"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  label="R.Q."
                  v-model="nome"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" sm="2">
                <v-text-field
                  label="Prioridade"
                  v-model="prioridade"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Observações"
                  v-model="observacao"
                  readonly
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="2">
                <v-text-field
                  label="Status"
                  v-model="statusDescrito"
                  readonly
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="2">
                <v-subheader><strong>Status</strong></v-subheader>
                <v-avatar
                  v-if="requisicao.status == 'AA'"
                  color="red"
                  size="22"
                >
                  <span class="white--text text-h6">AA</span>
                </v-avatar>
                <v-avatar
                  v-if="requisicao.status == 'PA'"
                  color="red"
                  size="22"
                >
                  <span class="white--text text-h6">PA</span>
                </v-avatar>
                <v-avatar
                  v-if="requisicao.status == 'AP'"
                  color="yellow"
                  size="22"
                >
                  <span class="white--text text-h6">AP</span>
                </v-avatar>
                <v-avatar
                  v-if="requisicao.status == 'AT'"
                  color="yellow"
                  size="22"
                >
                  <span class="white--text text-h6">AT</span>
                </v-avatar>
                <v-avatar
                  v-if="requisicao.status == 'B'"
                  color="green"
                  size="22"
                >
                  <span class="white--text text-h6">B</span>
                </v-avatar>
                <v-avatar
                  v-if="requisicao.status == 'D'"
                  color="green"
                  size="22"
                >
                  <span class="white--text text-h6">D</span>
                </v-avatar>
                <v-avatar
                  v-if="requisicao.status == 'I'"
                  color="green"
                  size="22"
                >
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <strong v-html="statusDescrito"></strong>
              </v-col>
            </v-row>

            <v-card>
              <v-data-table
                :headers="headers2"
                hide-default-footer
                :items-per-page="-1"
                :items="filteredList"
              >
                <template v-slot:item.quantidadeAtendida="{ item }">
                  <v-text-field
                    v-model="item.quantidadeAtendida"
                    hide-details
                    single-line
                    type="number"
                    v-mask="['#####']"
                    :rules="[
                      (v) =>
                        (!!v && v >= 0 && v <= item.quantidadeAprovada) ||
                        'A quantidade deve ser 0 até a quantidade requisitada!',
                    ]"
                    @input="updateItem(item)"
                    required
                  >
                  </v-text-field>
                </template>
              </v-data-table>
            </v-card>

            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn @click="close" color="error" class="mr-4">
                  Voltar
                </v-btn>
                <v-btn @click="gerarDME" color="success" class="mr-4">
                  Gerar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { baixarRequisicaoAsync } from "../../../services/requisicaoService";
import { enviarSolicitacaoAsync } from "../../../services/solicitacaoService";
import { getUserName } from "../../../services/loginService";
import { mapState, mapActions } from "vuex";
import Produto from "../../Compras/Produto";
import { getUserPermission } from "@/services/loginService";
import moment from "moment";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "baixarRequisicao",
  data: () => ({
    idModulo: 10,
    prioridade: null,
    overlay: false,
    showModal: false,
    valid: true,
    id: null,
    nome: null,
    requisitante: null,
    idOrdemServico: null,
    descricao: null,
    observacao: null,
    status: null,
    observacaoAprovador: null,
    local: null,
    data: null,
    statusDescrito: null,
    unidadeAdm: null,
    produtosL: [],
    indexEdit: null,
    errorMessage: false,
    headers: [
      { text: "Id", value: "id", sortable: false },
      { text: "Item", value: "descricao", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      { text: "Aprovado", value: "autorizado", sortable: false },
      { text: "Qtd", value: "quantidadeAprovada", sortable: false },
      {
        text: "Qtd. Atender",
        value: "quantidadeAtendida",
        width: "10%",
      },
      {
        text: "Comprar",
        value: "quantidadeComprar",
        width: "10%",
      },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
    headers2: [
      { text: "Id", value: "id", sortable: false },
      { text: "Item", value: "descricao", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      { text: "Comprar", value: "quantidadeComprar", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("requisicao", ["requisicao"]),
    filteredList() {
      return this.produtosL.filter((p) => {
        return p.quantidadeComprar > 0;
      });
    },
  },
  methods: {
    ...mapActions("requisicao", ["updateRequisicaoBaixa"]),
    ...mapActions("solicitacao", ["atualizarSolicitacoes"]),
    isWriteOff(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.baixar;
    },
    async baixarSemValidacao() {
      this.overlay = true;
      try {
        const resposta = await baixarRequisicaoAsync(
          this.requisicao.id,
          this.observacaoAprovador == null ? "" : this.observacaoAprovador,
          this.requisicao.unidadeAdm,
          this.requisicao.idUnidadeAdm,
          this.requisicao.status,
          this.local,
          this.requisicao.idLocal,
          this.prioridade == "Normal" ? "1" : "2",
          this.requisicao.data,
          this.produtosL
        );
        if (!resposta || resposta?.status != 200) {
          this.$alert(
            resposta.message,
            "Desculpe, falha na operação!",
            "error"
          );
        } else {
          this.updateRequisicaoBaixa(this.mountObjRequisicao());
          this.$store.dispatch("ui/showSnackbar", {
            text: "Requisição baixada!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push({
            path: "/baixaRequisicao",
            query: this.$route.query,
          });
        }
      } finally {
        this.overlay = false;
      }
    },
    async baixar() {
      if (this.$refs.form.validate()) {
        for (var i = 0; i < this.produtosL.length; i++) {
          if (
            this.produtosL[i].quantidadeAtendida >
              this.produtosL[i].quantidadeAprovada ||
            this.produtosL[i].quantidadeAtendida < -1
          ) {
            this.errorMessageValue =
              "A quantidade deve ser entre 0 até a mesma quantidade aprovada!";
            this.errorMessage = true;
            break;
          }
        }
        if (this.errorMessage) {
          return;
        }
        this.errorMessage = true;
        this.errorMessageValue =
          "A quantidade de pelo menos 1 dos items deve ser maior que zero!";
        for (var i = 0; i < this.produtosL.length; i++) {
          if (this.produtosL[i].quantidadeAtendida > 0) {
            this.errorMessage = false;
            break;
          }
        }
        if (this.errorMessage) {
          return;
        }

        this.overlay = true;
        try {
          const resposta = await baixarRequisicaoAsync(
            this.requisicao.id,
            this.observacaoAprovador == null ? "" : this.observacaoAprovador,
            this.requisicao.unidadeAdm,
            this.requisicao.idUnidadeAdm,
            this.requisicao.status,
            this.local,
            this.requisicao.idLocal,
            this.prioridade == "Normal" ? "1" : "2",
            this.requisicao.data,
            this.produtosL
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.updateRequisicaoBaixa(this.mountObjRequisicao());
            this.$store.dispatch("ui/showSnackbar", {
              text: "Requisição baixada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/baixaRequisicao",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      }
    },
    async gerarDME() {
      this.overlay = true;
      try {
        this.showModal = false;

        const respostaBaixa = await baixarRequisicaoAsync(
          this.requisicao.id,
          this.observacaoAprovador == null ? "" : this.observacaoAprovador,
          this.requisicao.unidadeAdm,
          this.requisicao.idUnidadeAdm,
          this.requisicao.status,
          this.local,
          this.requisicao.idLocal,
          this.prioridade == "Normal" ? "1" : "2",
          this.requisicao.data,
          this.produtosL
        );
        console.log(respostaBaixa);
        if (!respostaBaixa || respostaBaixa?.status != 200) {
          this.overlay = false;
          this.$alert("Desculpe, falha na operação de baixa!", "error");
          return;
        } else {
          if (this.requisicao.status === "AA") {
            this.requisicao.status = 1;
          } else if (this.requisicao.status === "PA") {
            this.requisicao.status = 2;
          } else if (this.requisicao.status === "GS") {
            this.requisicao.status = 3;
          } else if (this.requisicao.status === "AP") {
            this.requisicao.status = 4;
          } else if (this.requisicao.status === "AT") {
            this.requisicao.status = 5;
          } else if (this.requisicao.status === "B") {
            this.requisicao.status = 6;
          } else if (this.requisicao.status === "D") {
            this.requisicao.status = 7;
          } else if (this.requisicao.status === "I") {
            this.requisicao.status = 8;
          }
          this.updateRequisicaoBaixa(this.mountObjRequisicao());
          this.filteredList.forEach((item) => {
            item.quantidade = item.quantidadeComprar;
            item.id = 0;
          });
          const resposta = await enviarSolicitacaoAsync(
            this.requisicao.id,
            this.requisicao.prioridade == "Normal" ? "1" : "2",
            this.requisicao.idUnidadeAdm,
            this.requisicao.idLocal,
            this.requisicao.observacao,
            this.filteredList
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert("Desculpe, falha na operação!", "error");
          } else {
            await this.atualizarSolicitacoes();
            this.$store.dispatch("ui/showSnackbar", {
              text: "Requisição baixada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push("/solicitacao");
          }
        }
      } finally {
        this.overlay = false;
      }
    },
    updateItem(item) {
      if (
        Number(item.quantidadeAprovada) - Number(item.quantidadeAtendida) >=
        0
      ) {
        this.produtosL[item.index].quantidadeComprar =
          Number(item.quantidadeAprovada) - Number(item.quantidadeAtendida);
      } else {
        this.produtosL[item.index].quantidadeComprar = 0;
      }

      this.produtosL = JSON.parse(JSON.stringify(this.produtosL));
    },
    gerar() {
      this.showModal = true;
      this.labelModal = "Gerar Solicitação";
      //pegarDataAgora();
    },
    //pegarDataAgora() { this.dataIni = moment(data, "DD/MM/YYYY").format("YYYY-MM-DD"); },
    close() {
      this.showModal = false;
      this.labelModal = "";
      this.criar = false;
    },
    mountObjRequisicao() {
      try {
        var requisicao = new Object();
        requisicao.id = this.requisicao.id;
        requisicao.observacao = this.requisicao.observacao;
        requisicao.status = "B";
        requisicao.prioridade = this.requisicao.prioridade;
        requisicao.idUnidadeMedida = this.requisicao.idUnidadeMedida;
        requisicao.idLocal = this.requisicao.idLocal;
        requisicao.local = this.requisicao.local;
        requisicao.idUnidadeAdm = this.requisicao.idUnidadeAdm;
        requisicao.unidadeAdm = this.requisicao.unidadeAdm;
        requisicao.ativo = this.requisicao.ativo;
        requisicao.data = this.requisicao.data;
        requisicao.produtos = this.produtosL;
        requisicao.observacaoAutorizador = this.observacaoAprovador;
        return requisicao;
      } catch (e) {
        alert(e);
      }
    },
    isGreaterThanZero() {
      return !(
        this.produtosL.filter((item) => item.quantidadeComprar > 0).length > 0
      );
    },
    isEqualToZero() {
      return (
        this.produtosL.filter((item) => item.quantidadeComprar > 0).length > 0
      );
    },
  },
  created: function () {
    this.data = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
    var index = 0;
    this.prioridade =
      this.requisicao.prioridade == "Normal" ? "Normal" : "Emergencial";
    this.requisicao.prioridade == 1 ? "Normal" : "Emergencial";
    this.id = this.requisicao.id;
    this.nome = this.requisicao.nome;
    this.requisitante = this.requisicao.requisitante;
    this.idOrdemServico =
      this.requisicao.idOrdemServico == null ||
      this.requisicao.idOrdemServico == 0
        ? "NA"
        : this.requisicao.idOrdemServico;
    this.produtosL = this.requisicao.produtos;
    this.local = this.requisicao.local;
    this.unidadeAdm = this.requisicao.unidadeAdm;
    this.observacao = this.requisicao.observacao;
    this.status = this.requisicao.status;

    if (this.requisicao.status == "AA") {
      this.statusDescrito = "Aguardando Aprovação";
    } else if (this.requisicao.status == "PA") {
      this.statusDescrito = "Pendente Almoxarifado";
    } else if (this.requisicao.status == "GS") {
      this.statusDescrito = "Gerada Solicitação";
    } else if (this.requisicao.status == "AP") {
      this.statusDescrito = "Atendida Parcial";
    } else if (this.requisicao.status == "AT") {
      this.statusDescrito = "Atendida Total";
    } else if (this.requisicao.status == "B") {
      this.statusDescrito = "Baixada";
    } else if (this.requisicao.status == "D") {
      this.statusDescrito = "Declinada";
    } else {
      this.statusDescrito = this.status;
    }

    /*this.produtosL.forEach(
      (e) => (e["index"] = index++),
      (e["quantidadeAprovada"] = 0)
    );*/

    for (var i = 0; i < this.produtosL.length; i++) {
      this.produtosL[i]["index"] = index++;
      this.produtosL[i]["quantidadeComprar"] = 0;
      this.produtosL[i]["quantidadeAtendida"] =
        this.produtosL[i]["quantidadeAprovada"];
    }
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>
